<template>
  <div class="optin">
    <form @submit.prevent="submit()">
      <BaseLockup class="lockup"/>
      <div class="main">
        <BaseCheckbox
          value="optIn"
          type="checkbox"
          :checked="optIn"
          :required="false"
          label="Opt in to receive updates from UFC"
          @input="optIn = $event"
          v-if="userProfile.email"
        />
        <BaseInput
          :value="email"
          type="email"
          placeholder="Email address"
          @input="email = $event"
          :required="false"
          v-else
        />
        <BaseText7 class="terms" :text="$content.terms"/>
      </div>
      <button class="submit-button" type="submit">
        <BaseButtonRectangle>
          <BaseText6 text="Continue"/>
        </BaseButtonRectangle>
      </button>
    </form>
  </div>
</template>

<script>
import BaseInput from '@/components/BaseInput/BaseInput'
import BaseCheckbox from '@/components/BaseCheckbox/BaseCheckbox'
import BaseLockup from '@/components/BaseLockup/BaseLockup'
import BaseText7 from '@/components/BaseText7/BaseText7'
import BaseText6 from '@/components/BaseText6/BaseText6'
import BaseButtonRectangle from '@/components/BaseButtonRectangle/BaseButtonRectangle'
import UserService from '@/services/UserService'
import { mapState } from 'vuex'
export default {
  name: 'optin',
  components: {
    BaseLockup,
    BaseInput,
    BaseCheckbox,
    BaseText6,
    BaseText7,
    BaseButtonRectangle
  },
  data () {
    return {
      email: '',
      optIn: false
    }
  },
  mounted () {
    localStorage.setItem('userHasSeenOptin', true)
  },
  computed: mapState('user', [
    'userProfile'
  ]),
  methods: {
    async submit () {
      if (!this.optIn && !this.email) return this.$router.push('/')
      const body = { optIn: true }
      if (this.email) body.email = this.email
      await UserService.update(this.userProfile._id, body)
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
.optin {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  @media #{$media-3} {
    height: auto;
    margin: auto;
    max-width: 30rem;
  }
}
form {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
}
.lockup {
  width: 8.5rem !important;
}
.main {
  width: 100%;
  height: 100%;
  padding-top: 10rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  *:not(:last-child) {
    margin-bottom: 2rem;
  }
  @media #{$media-3} {
    margin-bottom: 5rem;
    padding-top: 7.5rem;
  }
}
.submit-button {
  width: 100%;
  flex-shrink: 0;
}
</style>
